import { Tooltip as Tooltips } from "@progress/kendo-react-tooltip";
import { useMemo } from "react";

interface ITooltip {
  content: React.ReactNode;
  anchorElement?: "target" | "pointer";
  position: "left" | "right" | "top" | "bottom";
  openDelay?: number;
  parentTitle?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties
}

const Tooltip = ({
  content,
  position,
  openDelay = 250,
  parentTitle = true,
  anchorElement = 'target',
  children,
  style,
}: ITooltip) => {
  const tooltipContent = useMemo(() => children || content, [children, content])

  return (
    <Tooltips
      anchorElement={anchorElement}
      position={position}
      openDelay={openDelay}
      parentTitle={parentTitle}
      style={style}
    >
      {tooltipContent}
    </Tooltips>
  )
}

export default Tooltip;